import Vue from 'vue'
import Router from 'vue-router'
import Users from '@/components/bg/Users'
import Product from '@/components/bg/Products'
import Unit from '@/components/bg/Units'
import Part from '@/components/bg/Parts'
import Websocket from '@/websocket/client'
import ResetPasswordAdmin from '@/components/bg/ResetPassword'
// import Class from '@/components/class/Class'
import ClassNew from '@/components/class/ClassNew'
import Series from '@/components/class/Series'
// import Mobile from '@/components/class/Mobile'
import QRListening from '@/components/bg/QRListening'
import QRStudy from '@/components/qrlistening/qrstudy'
import QrHome from '@/components/qrlistening/home'
import Review from '@/components/bg/SchoolReview'
import pointClass from '@/view/point/class'
import Auth from '@/view/authcode/auth'
import gsound from '@/view/game/sound/index'
import gword from '@/view/game/word/index'
import gameIndex from '@/view/game/index'
import gameManage from '@/view/game/manage/index'
import MenuManage from '@/components/bg/MenuManage'

// 认证页面（独立页面，无后台菜单）
import Login from '@/view/auth/Login'
import Register from '@/view/auth/Register'
import ResetPassword from '@/view/auth/ResetPassword'
import SchoolRegister from '@/view/auth/SchoolRegister'

// 认证工具d
import auth from '@/utils/auth'
import api from '@/utils/api'

Vue.use(Router)

const router = new Router({
  routes: [
    // ==================== 认证页面（独立页面） ====================
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { title: '登录', pageType: 'auth', requiresAuth: false }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: { title: '注册', pageType: 'auth', requiresAuth: false }
    },
    {
      path: '/school-register',
      name: 'SchoolRegister',
      component: SchoolRegister,
      meta: { title: '学校开户注册', pageType: 'auth', requiresAuth: false }
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: { title: '重置密码', pageType: 'auth', requiresAuth: false }
    },

    // ==================== 前台业务路由（需要登录） ====================
    {
      path: '/',
      name: 'home',
      components: { class: ClassNew },
      meta: { title: '首页', pageType: 'front', requiresAuth: true }
    },
    // {
    //   path: '/class-bak',
    //   name: 'class',
    //   components: { class: Class },
    //   meta: { title: '学习课程', pageType: 'front', requiresAuth: true }
    // },
    {
      path: '/class',
      name: 'classNew',
      components: { class: ClassNew },
      meta: { title: '学习课程(新)', pageType: 'front', requiresAuth: true }
    },
    {
      path: '/series',
      name: 'serie',
      component: Series,
      meta: { title: '系列', pageType: 'front', requiresAuth: true }
    },
    // {
    //   path: '/mobile',
    //   name: 'mobile',
    //   components: { class: Mobile },
    //   meta: { title: '移动端', pageType: 'front', requiresAuth: true }
    // },
    {
      path: '/chat',
      name: 'Websocket',
      components: { class: Websocket },
      meta: { title: '其他', pageType: 'front', requiresAuth: true }
    },
    {
      path: '/qrstudy',
      name: 'QrStudy',
      components: { class: QRStudy },
      meta: { title: '二维码学习', pageType: 'front', requiresAuth: true }
    },
    {
      path: '/qrhome',
      name: 'QrHome',
      components: { class: QrHome },
      meta: { title: '二维码首页', pageType: 'front', requiresAuth: true }
    },
    {
      path: '/point',
      name: 'point',
      components: { class: pointClass },
      meta: { title: '点读', pageType: 'front', requiresAuth: false }
    },
    {
      path: '/gsound',
      name: 'gsound',
      components: { class: gsound },
      meta: { title: '声音游戏', pageType: 'front', requiresAuth: true }
    },
    {
      path: '/gword',
      name: 'gword',
      components: { class: gword },
      meta: { title: '单词游戏', pageType: 'front', requiresAuth: true }
    },
    {
      path: '/game/index',
      name: 'gameIndex',
      components: { class: gameIndex },
      meta: { title: '游戏首页', pageType: 'front', requiresAuth: false }
    },

    // ==================== 后台管理路由（需要登录 + admin 角色） ====================
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: { title: '用户管理', pageType: 'admin', requiresAuth: true }
    },
    {
      path: '/products',
      name: 'Product',
      component: Product,
      meta: { title: '产品管理', pageType: 'admin', requiresAuth: true }
    },
    {
      path: '/units',
      name: 'Unit',
      component: Unit,
      meta: { title: '单元管理', pageType: 'admin', requiresAuth: true }
    },
    {
      path: '/parts',
      name: 'Part',
      component: Part,
      meta: { title: '课件管理', pageType: 'admin', requiresAuth: true }
    },
    {
      path: '/listening',
      name: 'Listening',
      component: QRListening,
      meta: { title: '二维码', pageType: 'admin', requiresAuth: true }
    },
    {
      path: '/review',
      name: 'Review',
      component: Review,
      meta: { title: '资质审核', pageType: 'admin', requiresAuth: true }
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth,
      meta: { title: '授权码', pageType: 'admin', requiresAuth: true }
    },
    {
      path: '/service/reset-pwd',
      name: 'ResetPasswordAdmin',
      component: ResetPasswordAdmin,
      meta: { title: '重置密码', pageType: 'admin', requiresAuth: true }
    },
    {
      path: '/game/manage',
      name: 'gameManage',
      component: gameManage,
      meta: { title: '转换语音', pageType: 'admin', requiresAuth: true }
    },
    {
      path: '/menu',
      name: 'MenuManage',
      component: MenuManage,
      meta: { title: '菜单管理', pageType: 'admin', requiresAuth: true }
    }
  ]
})
/**
 * 检查用户是否有权限访问指定页面类型
 * @param {string} pageType - 页面类型
 * @param {string} roles - 用户角色字符串
 * @returns {boolean}
 */
function hasPageAccess (pageType, roles) {
  // 认证页面任何人都可以访问
  if (pageType === 'auth') return true

  // 前台页面，已登录用户都可以访问
  if (pageType === 'front') return true

  // 后台页面，需要 admin 角色
  if (pageType === 'admin') {
    const rolesLower = (roles || '').toLowerCase()
    return rolesLower.includes('admin')
  }

  return false
}

/**
 * 获取用户默认首页路径
 * @returns {string}
 */
function getDefaultPath () {
  return Vue.prototype.$defaultPath || '/'
}

/**
 * 获取用户角色
 * @returns {string}
 */
function getUserRoles () {
  const userInfo = Vue.prototype.$userInfo
  return userInfo ? userInfo.roles : ''
}

/**
 * 主动获取用户信息（用于登录后首次访问时的初始化）
 * @returns {Promise<object|null>}
 */
async function fetchUserInfo () {
  if (Vue.prototype.$userInfo) return Vue.prototype.$userInfo

  try {
    // 动态导入 axios，避免循环依赖
    const axios = (await import('@/utils/axios')).default
    const response = await axios.post(api.getUserInfo)
    if (response.data && response.data.result) {
      Vue.prototype.$userInfo = response.data.result
      console.log('[Router] 主动获取用户信息成功:', response.data.result)
      return response.data.result
    }
  } catch (error) {
    console.error('[Router] 主动获取用户信息失败:', error)
  }
  return null
}

/**
 * 主动获取菜单和默认首页（用于登录后首次访问时的初始化）
 * @returns {Promise<string|null>}
 */
async function fetchMenuAndDefaultPath () {
  if (Vue.prototype.$defaultPath && Vue.prototype.$menuList) return Vue.prototype.$defaultPath

  try {
    // 动态导入 axios，避免循环依赖
    const axios = (await import('@/utils/axios')).default

    // 获取菜单列表
    const menuResponse = await axios.get(api.getUserMenus)
    let menuList = []
    if (menuResponse.data && menuResponse.data.result && menuResponse.data.result.length > 0) {
      menuList = menuResponse.data.result
      Vue.prototype.$menuList = menuList
      console.log('[Router] 主动获取菜单成功:', menuList.length, '个菜单')
    }

    // 获取默认首页
    const response = await axios.get(api.getDefaultMenu)
    if (response.data && response.data.result && response.data.result.index) {
      Vue.prototype.$defaultPath = response.data.result.index
      console.log('[Router] 主动获取默认首页成功:', Vue.prototype.$defaultPath)
      return Vue.prototype.$defaultPath
    } else if (menuList.length > 0) {
      // 如果没有默认首页，使用第一个菜单
      const firstMenu = menuList[0]
      const defaultPath = firstMenu.children && firstMenu.children.length > 0
        ? firstMenu.children[0].index
        : firstMenu.index
      Vue.prototype.$defaultPath = defaultPath
      console.log('[Router] 使用第一个菜单作为默认首页:', defaultPath)
      return defaultPath
    }
  } catch (error) {
    console.error('[Router] 主动获取菜单和默认首页失败:', error)
  }
  return null
}

// 全局前置路由守卫
router.beforeEach(async (to, from, next) => {
  const pageType = to.meta && to.meta.pageType
  const requiresAuth = to.meta.requiresAuth !== false

  // 调试日志
  console.log('[Router Guard] 导航到:', to.path, 'pageType:', pageType)

  // Step 0: 异常路由兜底，避免错误路径在守卫里递归跳转
  if (!to.matched || to.matched.length === 0 || typeof pageType === 'undefined') {
    console.warn('[Router Guard] 未匹配到有效路由，重定向处理:', to.fullPath)
    if (auth.isLoggedIn()) {
      const defaultPath = getDefaultPath()
      return next(defaultPath && defaultPath !== to.path ? defaultPath : '/')
    }
    const redirect = encodeURIComponent(to.fullPath || to.path || '/')
    return next({ path: '/login', query: { redirect }, replace: true })
  }

  // Step 1: 认证页面处理
  if (pageType === 'auth') {
    // 已登录用户访问登录页，重定向到默认首页
    if (to.path === '/login' && auth.isLoggedIn()) {
      // 先获取必要数据
      if (!Vue.prototype.$userInfo) {
        await fetchUserInfo()
      }
      if (!Vue.prototype.$defaultPath) {
        await fetchMenuAndDefaultPath()
      }
      return next(getDefaultPath())
    }
    // 其他认证页面直接放行
    return next()
  }

  // Step 2: 登录检测
  if (requiresAuth && !auth.isLoggedIn()) {
    // 未登录，跳转到登录页，记录原目标路径
    const redirect = encodeURIComponent(to.fullPath)
    console.log('[Router Guard] 未登录，跳转到登录页')
    return next({ path: '/login', query: { redirect }, replace: true })
  }

  // Step 3: 如果用户信息为空，主动获取用户信息和菜单
  if (auth.isLoggedIn() && !Vue.prototype.$userInfo) {
    console.log('[Router Guard] 用户信息为空，主动获取...')
    await fetchUserInfo()
  }

  // Step 4: 如果菜单或默认首页未设置，主动获取
  if (auth.isLoggedIn() && !Vue.prototype.$menuList) {
    console.log('[Router Guard] 菜单未设置，主动获取...')
    await fetchMenuAndDefaultPath()
  }

  // Step 5: 根路径特殊处理 - 已登录用户跳转默认首页
  if (to.path === '/' && auth.isLoggedIn()) {
    const defaultPath = getDefaultPath()
    console.log('[Router Guard] 根路径访问，默认首页:', defaultPath)
    if (defaultPath && defaultPath !== '/') {
      console.log('[Router Guard] 跳转到默认首页:', defaultPath)
      return next(defaultPath)
    }
  }

  // Step 6: 页面权限检查
  const roles = getUserRoles()
  console.log('[Router Guard] 用户角色:', roles, '目标页面类型:', pageType, '权限检查结果:', hasPageAccess(pageType, roles))

  if (!hasPageAccess(pageType, roles)) {
    // 权限不足，跳转到默认首页
    console.log('[Router Guard] 权限不足，跳转到:', getDefaultPath())
    return next(getDefaultPath())
  }

  // Step 7: 放行
  console.log('[Router Guard] 放行到:', to.path)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js